// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_5QYl-","ad_1":"index_ad_1_msLHP","ad_2":"index_ad_2_yXmSq","wrap":"index_wrap_V4FRN"};